// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  FormSection,
  InputHtml,
} from '@vroskus/library-components';

// Helpers
import {
  cleanFormValues,
} from '@vroskus/library-helpers/dist/browser';
import {
  defaultUpsertItem,
} from '../../../../helpers';

// Services
import Services from '../../../../services';

// Types
type $Props = $Translate & {
  id: string;
  item: $Model<'Championship'>;
};

type $State = {
  changed: boolean;
  value?: null | string;
};

class ChampionshipDescriptionSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      changed: false,
      value: props.item.Content,
    };
  }

  render() {
    const {
      id,
      item,
      t,
    } = this.props;
    const {
      changed,
      value,
    } = this.state;

    return (
      <FormSection
        changed={changed}
        fields={(
          <InputHtml
            name={'Content'}
            onChange={() => this.setState({
              changed: true,
            })}
            value={value}
          />
        )}
        headerIconClass={'icon-note'}
        headerTitle={t('Championship description')}
        id={id}
        labelClearButton={t('Clear')}
        labelSaveButton={t('Save')}
        onAction={(values) => defaultUpsertItem({
          action: async () => {
            const params = cleanFormValues<$Model<'Championship'>>({
              ...item,
              ...values,
            });

            await Services.Api.upsertChampionship(params);

            this.setState({
              changed: false,
              value: item.Content,
            });
          },
        })}
        onClear={() => this.setState({
          changed: false,
        })}
      />
    );
  }
}

export default ChampionshipDescriptionSectionView;
